<template>
    <v-app class="root">
        <v-app-bar
            v-if="$vuetify.breakpoint.smAndUp"
            app
            clipped-right
            color="#128c7e"
            height="100"
            dark
        >
        <img
            :src="require('@/assets/images/whataspp-desktop.svg')"
            style="width: 160px; margin-left: 5%;"
        />
        <v-spacer />
        </v-app-bar>
        <v-app-bar v-else app clipped-right color="#128c7e" height="70" flat dark>
        <img
            :src="require('@/assets/images/whataspp-mobile.svg')"
            style="width: 35px; margin-left: 5%;"
            alt="whataspp"
        />
        <span class="open-whatsapp-text ml-4">Abrir o WhatsApp</span>
        <v-spacer />
        </v-app-bar>

        <v-container style="display: flex; justify-content: center;">
            <v-card width="1000" elevation="0" light>
                <v-card-text class="text-center" style="padding-top: 100px;">
                    <v-avatar size="140" class="mx-auto">
                        <img :src="require('@/assets/images/zapermenu-profile.png')" alt="ZaperMenu Logo" />
                    </v-avatar>
                    <div style="display: flex; justify-content: center; margin-top: 30px;">
                        <h2>
                        {{ title }}
                        </h2>
                    </div>
                </v-card-text>

                <v-card-text :style="`height: ${$vuetify.breakpoint.height - 380}px; padding: 0 10%; margin-top: 30px; text-align: center;`">
                    <!-- <h3 style="font-weight: 400;">Em breve um de nossos especialistas entrará em contato.</h3> -->
                    <h3 style="font-weight: 500; margin-top: 50px;">
                        Nosso horário de atendimento é das 08h:00 às 18h:00 de segunda a sexta.
                    </h3>
                    <div style="display: flex; width: 100%; justify-content: center; margin-top: 50px;">
                        <v-btn
                            color="#128c7e"
                            rounded
                            height="60"
                            width="220"
                            class="white--text pulse-button"
                            @click="startConversation"
                        >
                            Iniciar conversa
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { trackClick } from '@/utils/lpTracker';
import { urlConversaWhatsapp } from '@/utils/conversaWhatsapp';

export default {
    name: 'Thanks',

    data: () => ({
        urlParams: null,
        title: '',
    }),

    mounted() {
        document.title = 'Obrigado | ZaperMenu';
        const urlParams = new URLSearchParams(window.location.search);

        const name = urlParams.get('name');

        this.title = name ? `Obrigado, ${name}!` : 'Obrigado!';
    },

    computed: {
        ...mapState([
            'plan',
        ]),

        getPrice() {
            return this.plan.price;
        },
    },

    methods: {
        startConversation() {
            trackClick('Thanks - Iniciar conversa');

            window.open(urlConversaWhatsapp(this.$store.state.urlParams.produto), '_blank');
        },
    },
};
</script>

<style scoped lang="scss">
.root {
    background: #fff;
    background-color: #f0f4f9;
    width: 100vw;
}

.main-container {
    margin: 0 5% 0 5%;
    color: #000;
    display: flex;
    justify-content: center;
}

.pulse-button {
    position: relative;
    overflow: hidden;
    animation: pulseGlow 2.4s ease-in-out infinite;
    background-color: #128C7E !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 0 0 rgba(18, 140, 126, 0.3);
    font-weight: 600;
    letter-spacing: 0.5px;
}

.pulse-button:hover {
    transform: scale(1.07);
    box-shadow: 0 0 20px rgba(18, 140, 126, 0.4);
}

@keyframes pulseGlow {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(18, 140, 126, 0.45);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 0 10px rgba(18, 140, 126, 0.0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(18, 140, 126, 0);
    }
}

.pulse-button::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.pulse-button:hover::after {
    opacity: 1;
}
</style>
